import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-startups',
  templateUrl: './business-startups.component.html',
  styleUrls: ['./business-startups.component.scss']
})
export class BusinessStartupsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
